<script>
    export default {
        props: ['initPublishUrl'],
        methods: {
            submit: function(event) {
                this.$refs.publishButton.setAttribute('disabled', 'disabled');
                // send post
                this.$http.get(
                    this.initPublishUrl,
                ).then((response) => {
                    // reload and show alert (set with messages in server)
                    window.location.reload();
                }).catch((error) => {
                    // redirect or show error alert
                    if(error.response && error.response.data.redirect){
                        window.location.href = error.response.data.redirect;
                    }else{
                        window.showErrorTopAlertWithTimer();
                    }
                    this.$refs.publishButton.removeAttribute('disabled');
                });                
            },
        }
    };
</script>